// @flow

import * as React from 'react';
import SimpleLinkSection from './SimpleLinkSection';
import type { SimpleLink } from './SimpleLinkSection';

type Props = {
  links: SimpleLink[],
};

const ExploreLinksSections = ({ links }: Props) => (
  <div>
    <SimpleLinkSection links={links} />
  </div>
);

export default ExploreLinksSections;
